import * as tslib_1 from "tslib";
import { createAxiosClient, formatUrl } from './utilities';
import { GenericErrorResponseCode } from '@tradingblock/types';
function toApiResponse(legacyResponse) {
    return {
        payload: legacyResponse.Payload,
        responseCode: legacyResponse.ResponseCode,
        errors: legacyResponse.Errors,
    };
}
export class ApiClient {
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    constructor(rootUrl, authKey) {
        this.rootUrl = rootUrl;
        this.authKey = authKey;
        this.http = createAxiosClient(rootUrl, authKey);
        this.config = {
            headers: {},
        };
    }
    authenticated(authKey) {
        this.config.headers['Authorization'] = authKey || this.authKey;
        return this;
    }
    withResponseHandler({ onResponse, onResponseError, }) {
        this.http.interceptors.response.use(onResponse, onResponseError);
        return this;
    }
    get(path, params, options) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const combinedConfig = Object.assign({}, this.config, (options || {}));
            try {
                const response = yield this.http.get(formatUrl(path, params), combinedConfig);
                if (!response || !response.data) {
                    return {
                        responseCode: GenericErrorResponseCode,
                        payload: null,
                        errors: ['No response received from server'],
                    };
                }
                return toApiResponse(response.data);
            }
            catch (error) {
                // Normalize Axios errors to expose HTTP status (e.g., 429, 401, 403) to callers
                const maybeAxios = error;
                const status = maybeAxios && maybeAxios.response && maybeAxios.response.status;
                if (status === 429) {
                    const retryAfter = maybeAxios.response && maybeAxios.response.headers && maybeAxios.response.headers['retry-after'];
                    return {
                        responseCode: GenericErrorResponseCode,
                        payload: null,
                        errors: ['status code 429', retryAfter ? `retry-after: ${String(retryAfter)}` : 'rate limited'],
                    };
                }
                if (status === 401 || status === 403) {
                    return {
                        responseCode: status,
                        payload: null,
                        errors: [maybeAxios && maybeAxios.message ? maybeAxios.message : `HTTP ${status}`],
                    };
                }
                console.error('API request failed:', error);
                return {
                    responseCode: GenericErrorResponseCode,
                    payload: null,
                    errors: [maybeAxios && maybeAxios.message ? maybeAxios.message : 'Unknown error occurred'],
                };
            }
        });
    }
    getBinary(path, params, options) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const combinedConfig = Object.assign({}, this.config, (options || {}));
            return this.http.get(formatUrl(path, params), Object.assign({}, combinedConfig, { responseType: 'arraybuffer' }));
        });
    }
    post(path, payload, options) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const _a = options || { queryParams: undefined }, { queryParams } = _a, config = tslib_1.__rest(_a, ["queryParams"]);
            const combinedConfig = Object.assign({}, this.config, config);
            return this.http
                .post(formatUrl(path, queryParams || undefined), payload, combinedConfig)
                .then(res => res.data)
                .then(toApiResponse);
        });
    }
    put(path, payload, options) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const _a = options || { queryParams: undefined }, { queryParams } = _a, config = tslib_1.__rest(_a, ["queryParams"]);
            const combinedConfig = Object.assign({}, this.config, config);
            return this.http
                .put(formatUrl(path, queryParams || undefined), payload, combinedConfig)
                .then(res => res.data)
                .then(toApiResponse);
        });
    }
    delete(path, params, options) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const combinedConfig = Object.assign({}, this.config, (options || {}));
            return this.http
                .delete(formatUrl(path, params), combinedConfig)
                .then(res => res.data)
                .then(toApiResponse);
        });
    }
}
export class UiApiClient {
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    constructor(rootUrl, authKey) {
        this.rootUrl = rootUrl;
        this.authKey = authKey;
        this.http = createAxiosClient(rootUrl, authKey);
        this.config = {
            headers: {},
        };
    }
    authenticated(authKey) {
        this.config.headers['Authorization'] = authKey || this.authKey;
        this.config.withCredentials = true;
        return this;
    }
    with(func) {
        this.config = func(this.config);
        this.config.withCredentials;
        return this;
    }
    withResponseHandler({ onResponse, onResponseError, }) {
        this.http.interceptors.response.use(onResponse, onResponseError);
        return this;
    }
    get(path, params, options) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const combinedConfig = Object.assign({}, this.config, (options || {}));
            return this.http.get(formatUrl(path, params), combinedConfig).then(res => res.data);
        });
    }
    post(path, payload, options) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const _a = options || { queryParams: undefined }, { queryParams } = _a, config = tslib_1.__rest(_a, ["queryParams"]);
            const combinedConfig = Object.assign({}, this.config, config);
            return this.http.post(formatUrl(path, queryParams || undefined), payload, combinedConfig).then(res => res.data);
        });
    }
}
//# sourceMappingURL=ApiClient.js.map